export const lightTheme = {
  text: {
    main: '#212c3a',
    secondary: '#8d94ad',
    tertiary: '#b1b8c6',
    quaternary: '#f9f9f9'
  },
  bg: {
    main: '#fefefe',
    secondary: '#f6f7fa',
    tertiary: '#ffe6e5',
    quaternary: '#f6f7fa',
    filters: '#fafcfd'
  },
  border: {
    main: '#eaebf2',
    secondary: '#f1f3f7',
    tertiary: '#dfe3e9'
  },
  system: {
    blue: '#4c88f9',
    deepBlue: '#4264fd',
    lightBlue: '#dae8ff',
    green: {
      default: '#3db460',
      selected: '#2b7f44',
      hovered: '#32914e'
    },
    red: '#ff586d',
    yellow: '#ffb900',
    white: '#ffffff',
    black: '#1a1a1a',
    darkRed: '#b80d13'
  },
  hover: {
    lightGreen: '#85c01f',
    blue: '#3273ec'
  },
  brand: {
    bump: '#77c81d',
    vip: '#ff3d00',
    premium: '#ff9f2b',
    mainRed: '#ca1016'
  },
  switcher: {
    sliderBackground: '#ffeea5'
  },
  dropShadow: {
    opacity15: 'rgba(0,0,0,0.15)'
  },
  dragger: '#d1d1d6',
  labels: {
    tertiary: '#b1b8c6'
  }
};
